import * as DictService from '../../services/dictionary.js'

/**
 * 缓存请求结果
 */
let DictionaryMap = {}

export default {
  getDictsByType (type) {
    if (!type) {
      return Promise.resolve([])
    }
    if (DictionaryMap[type] && DictionaryMap[type].data) {
      return Promise.resolve(DictionaryMap[type].data)
    }
    if (DictionaryMap[type] && DictionaryMap[type].loading) {
      return DictionaryMap[type].promise
    }
    DictionaryMap[type] = {}
    DictionaryMap[type].loading = true
    DictionaryMap[type].promise = DictService.getByType(type).then(data => {
      DictionaryMap[type].data = data.results.results
      return data.results.results
    })
    return DictionaryMap[type].promise
  },
  getNameByTypeAndValue (type, value) {
    return this.getDictsByType(type).then(dicts => {
      let results = value
      dicts.forEach(data => {
        // eslint-disable-next-line
        if (data.value == value) {
          results = data.name
        }
      })
      return results
    })
  }
}



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/dictionarySelect/dictionaryStore.js